import { Button } from "@mui/material"
import { R } from "../../R"
import { MemberDAO } from "../../dao/MemberDAO";
import { His_Api } from "../../dao/His_Api";
import { Toast } from "../../../libs/app-core/Toast";
import { useAppContext } from "../../../libs/app-core/AppContext";
import { SpwkToHisInfo } from "../FrmSpwkToHis/SpwkToHisInfo";
import { useState } from "react";
import CheckBox from "../../../libs/rhf-mui/ui/CheckBox";
import { useLocation } from "react-router-dom";
export type FrmHisManagerParams = {
    InfoList : SpwkToHisInfo[]
  }

type Props = {
    infoList: SpwkToHisInfo[];
}


const FrmHisManager = (props: Props) => {
    //#region 讀取網址參數
    let params = useLocation().state as FrmHisManagerParams;
    let InfoList: SpwkToHisInfo[] = params.InfoList ?? [];

    //#endregion
    const ctx = useAppContext();
    const [IsGovCode, set_IsGovCode] = useState<boolean>(true);
    const [IsHisCode, set_IsHisCode] = useState<boolean>(true);
    const [IsUiCode, set_IsUiCode] = useState<boolean>(true);

    async function 匯入院內_Click() {
        let count = 0;
        const MaxBatch = 100;
        const totalCount = InfoList.length;
        const jsonString = "{\"結果\":\"1\",\"訊息內容\":\"成功!\"}";
        console.log(jsonString)
        do {
            for (let i = count; i < count + MaxBatch && i < totalCount; i++) {
                const Info = InfoList[i];
                let member = await MemberDAO.WS_FetchByGuid(Info.Ans.member_guid);
            
                if (Info.HisDto != null) {
                    await His_Api.上傳Async(Info.HisDto, member, IsGovCode, IsUiCode, IsHisCode)
                    await new Promise(resolve => setTimeout(resolve, 500));
                }
            }
            const batchCount = Math.min(MaxBatch, totalCount - count);
            Toast.Show(ctx, `已執行完成 ${batchCount} 筆`);
            await new Promise(resolve => setTimeout(resolve, 2000));
            count += MaxBatch;
        } while (count < totalCount);
        alert("已執行完成")
        Toast.Show(ctx, "已執行完成");
    }

    return (
        <div>
            {render_CheckBox()}
            <Button variant='contained' size='small'
                sx={{
                    mx: 1,
                    bgcolor: R.color.accent,
                    ':hover': {
                        bgcolor: R.color.accent_light, // theme.palette.primary.main
                        color: 'white',
                    },
                }}
                onClick={匯入院內_Click}>
                匯入院內
            </Button>
        </div>
    )
    function render_CheckBox() {
        return (
            <div>
                <CheckBox label={"問卷申報"}
                    markProps={{
                        checked: IsGovCode,
                        onChange(event, checked) {
                            set_IsGovCode(checked);
                        },
                        style: {
                            color: "#EE7674",
                        }
                    }}
                />
                <CheckBox label={"問卷明細"}
                    markProps={{
                        checked: IsHisCode,
                        onChange(event, checked) {
                            set_IsHisCode(checked);
                        },
                        style: {
                            color: "#EE7674",
                        }
                    }}
                />
                <CheckBox label={"問卷UI基礎"}
                    markProps={{
                        checked: IsUiCode,
                        onChange(event, checked) {
                            set_IsUiCode(checked);
                        },
                        style: {
                            color: "#EE7674",
                        }
                    }}
                />
            </div>
        )
    }
}

export default FrmHisManager
